import {api} from "../../services";
import Swal from "sweetalert2";
import Timer from "easytimer.js";

const histories = {
  state: {
    data: [],
    tickets_called_api: [],
    history: {},
    lead: {},
    pagination: {},
    timer: new Timer(),
    search_email: {
      channel_id: null,
      department_id: null,
      operator_id: null,
      start_date: null,
      final_date: null,
      per_page: 10
    },
    search_hsm: {
      channel_id: null,
      department_id: null,
      operator_id: null,
      start_date: null,
      final_date: null,
      per_page: 10
    },
    search_sms: {
      channel_id: null,
      department_id: null,
      operator_id: null,
      start_date: null,
      final_date: null,
      per_page: 10
    },
    search_voip: {
      channel_id: null,
      department_id: null,
      operator_id: null,
      start_date: null,
      final_date: null,
      per_page: 10
    },
    search_nps: {
      channel_id: null,
      department_id: null,
      operator_id: null,
      start_date: null,
      final_date: null,
    },
    search_webhook: {
      channel_id: null,
      start_date: null,
      final_date: null,
      per_page: 10
    },
  },
  getters: {
    getHistoryObject: (state) => (key, value) => {
      const object = state.data.find(item => {
        return item[`${key}`] === value;
      });
      return object === undefined ? {} : object;
    },
    getHistoriesArray: (state) => (key, value) => {
      if (state.data !== undefined) {
        return state.data.filter(item => {
          return item[`${key}`] === value;
        });
      }
      return [];
    },
  },
  mutations: {
    SET_HISTORIES(state, payload) {
      state.data = payload
    },
    SET_TICKETS_CALLED_API(state, payload) {
      state.tickets_called_api.push(payload)
    },
    SET_HISTORY_LEAD(state, payload) {
      state.lead = payload
    },
    SET_HISTORIES_DATA(state, payload) {
      payload.forEach(p => {
        const exist = state.data.find(e => {
          return e.id === p.id;
        });
        if (!exist) {
          state.data.push(p);
        }
      });
    },
    SET_HISTORY(state, payload) {
      // TODO: Validar funcionamento. Limpar o history antes de exibir
      state.history = null
      state.history = payload
    },
    SET_HISTORY_REPORTS(state, payload) {
      state.pagination = payload
      this.dispatch("getTicketsData", payload.data);
      this.dispatch("getLeadsData", payload.data);
    },
  },
  actions: {
    getHistories(context, payload) {
      api.get('/histories', {
        params: payload
      }).then(response => {
        context.commit("SET_HISTORIES", response.data);
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    getHistoriesData(context, ticket_id) {
      // const ticket = context.state.tickets_called_api.find(ticket => {
      //   return ticket === ticket_id
      // });

      // if(!ticket) {
        api.post(`/histories/data`, {ticket_id}).then(response => {
          // context.commit("SET_TICKETS_CALLED_API", ticket_id);
          // context.commit("SET_HISTORIES_DATA", response.data);
          if(context.rootState.chat.ticket.id == ticket_id) {
            context.rootState.chat.histories_current_ticket = response.data
          }
          if(context.rootState.tickets.ticket.id == ticket_id) {
            context.rootState.tickets.histories_followup_ticket = response.data
          }
          if(window.route.name === 'Chat') {
            context.state.loading_chat = false;
          }
          // context.commit("SET_HISTORIES", response.data);
          // this.dispatch('hookActive');
        }).catch(error => {
          if (error.response.status === 401) {
            this.dispatch('logoutUser');
          }
        });
      // }
    },
    getHistoriesAll(context) {
      api.get(`/histories/all`).then(response => {
        context.commit("SET_HISTORIES_DATA", response.data);
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    clearHistory(context, payload) {
      api.post(`/histories/clear`, payload).then(response => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: context.rootGetters.getTranslations('expression_927'),
          showConfirmButton: false,
          timer: 1500
        })
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    setHistoryLead(context, payload) {
      context.commit("SET_HISTORY_LEAD", payload);
    },
    getHistoriesSms(context, payload) {
      api.get(`histories/report/sms`, {
        params: payload
      }).then(response => {
        context.commit("SET_HISTORY_REPORTS", response.data);
        this.dispatch('stopLoading');
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    getHistoriesEmail(context, payload) {
      api.get(`histories/report/email`, {
        params: payload
      }).then(response => {
        context.commit("SET_HISTORY_REPORTS", response.data);
        this.dispatch('stopLoading');
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    getHistoriesVoip(context, payload) {
      api.get(`histories/report/voip`, {
        params: payload
      }).then(response => {
        context.commit("SET_HISTORY_REPORTS", response.data);
        this.dispatch('stopLoading');
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    getHistoriesHsm(context, payload) {
      api.get(`histories/report/hsm`, {
        params: payload
      }).then(response => {
        context.commit("SET_HISTORY_REPORTS", response.data);
        this.dispatch('stopLoading');
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    getHistoriesWebhooks(context, payload) {
      api.get(`histories/webhook/failed`, {
        params: payload
      }).then(response => {
        context.commit("SET_HISTORY_REPORTS", response.data);
        this.dispatch('stopLoading');
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
  },
}
export default histories;
